import React from 'react';
import {
  LocationProvider as ReachLocationProvider,
  HistorySource,
  History,
} from '@reach/router';

interface Props {
  children: React.ReactNode;
  history: History | HistorySource;
}

// Cast to fix JSX typing issue
const LocationProvider = (ReachLocationProvider as unknown) as React.ComponentType<{
  history: HistorySource;
  children: React.ReactNode;
}>;

const LocationProviderWrapper: React.FC<Props> = ({ children, history }) => {
  const castedHistory = history as HistorySource;

  return (
    <LocationProvider history={castedHistory}>{children}</LocationProvider>
  );
};

export default LocationProviderWrapper;
